import QuestionReview from '@views/question-review/question-review.js'

export default {
  methods: {
    // 判断参考题目是否审核不通过
    isReferQuestionNotPassed (id) {
      let referIds = QuestionReview().getReferId(id)
      for (const questionId of referIds) {
        if (QuestionReview().isNotPassed(questionId)) {
          return true
        }
      }
      return false
    },
    // 判断参考题目(包括子孙)是否审核不通过
    isReferQuestionNotPassedRecursive (id, allQuesitonIds = []) {
      allQuesitonIds.push(id)
      let referIds = QuestionReview().getReferId(id)
      for (const questionId of referIds) {
        if (allQuesitonIds.includes(questionId)) {
          continue
        }
        if (QuestionReview().isNotPassed(questionId) || (this.isReferQuestionNotPassedRecursive(questionId, allQuesitonIds))) {
          return true
        }
      }
      return false
    },
    // 判断是否用户填的都是通过的
    isNotPassedByUserEmpty (notPassed, reviewNotPassed) {
      let isNotReview = false
      for (let index = 0; index < notPassed.length; index++) {
        if (!reviewNotPassed.includes(notPassed[index])) {
          isNotReview = true
        }
      }
      return !isNotReview
    },
    // 获得答案验证结果
    getAnswerValidateResult () {
      let errorNumbers = {
        evidence: [],
        answer: [],
        unaudited: [],
        notPassed: [],
        reviewNotPassed: []// 不通过的截断题号后的题目
      }
      let extendedStepsStart = QuestionReview().getExtendedStepsStart()
      let validQuestions = QuestionReview().getValidQuestions()
      for (let index = 0; index < validQuestions.length; index++) {
        const question = validQuestions[index]
        const answer = QuestionReview().getAnswer(question.id)
        const number = QuestionReview().getQuestion(question.id).index() + 1
        // 记录缺少证据的题目
        if (QuestionReview().needEvidence(question.id) && !QuestionReview().getEvidences(question.id).length) {
          errorNumbers.evidence.push(number)
        }
        // 记录答案格式不正确的题目
        if (!QuestionReview().validateAnswer(question.id)) {
          errorNumbers.answer.push(number)
        }
        // 未审核的题目，在参考题目不是不通过时
        // 参考题目审核不通过，也需要审核
        if (answer.isPassed === '10') {
          errorNumbers.unaudited.push(number)
        }
        // 审核不通过
        if (answer.isPassed === '30') {
          // 记录审核不通过的题目序号
          errorNumbers.notPassed.push(number)
          if (QuestionReview().getIndexe(question.id).index() >= extendedStepsStart) {
            errorNumbers.reviewNotPassed.push(number)
          }
        }
      }
      return errorNumbers
    },
    /**
     * 验证答案合法性
     * @param alertItems 需要提示的错误项目
     * @returns {Promise<any>}
     */
    validateAnswer (alertItems = ['answer', 'unaudited']) {
      return new Promise((resolve, reject) => {
        let result = this.getAnswerValidateResult()
        let {evidence, answer, unaudited} = result
        console.log(answer)
        // 题目未全部审核
        if (alertItems.includes('unaudited') && unaudited.length) {
          let errorMessage = `第${unaudited.join('、')}题未审核。`
          this.$alert(errorMessage, '提示', {type: 'error'})
          return reject(result)
        }
        // 输入内容格式校验
        // 格式不正确的题目的提示
        if (alertItems.includes('answer') && answer.length) {
          let errorMessage = `第${answer.join('、')}题答案格式错误，请查证后尝试再次提交。`
          this.$alert(errorMessage, '提示', {type: 'error'})
          return reject(result)
        } else {
          // 缺少证据的题目的提示
          if (evidence.length) {
            let errorMessage = `第${evidence.join('、')}题未提交证据，是否确认？`
            return this.$confirm(errorMessage, '提示', {type: 'warning'}).then(() => {
              resolve(result)
            }).catch(() => {
              return reject(result)
            })
          } else {
            return resolve(result)
          }
        }
      })
    },
    checkRankScore () {
      const max = 5
      if (this.orderDetail.rank_score === null) {
        this.$message.error('请对用户做单质量打分')
        return false
      }

      let maxScore = max - this.orderDetail.review
      maxScore = Math.max(1, maxScore)
      if (this.orderDetail.rank_score > 1 && this.orderDetail.rank_score > maxScore) {
        this.$message.error(`工单已经审核${this.orderDetail.review}次，最多可打${maxScore}分`)
        return false
      }

      return true
    },
    /**
     * 检查SJF订单验证
     * @returns {boolean} 验证是否通过
     */
    checkSJFOrderValid () {
      // 非SJF类型订单直接通过
      if (this.orderDetail.type !== '23') {
        return true
      }

      const validationResults = this.performSJFValidations()

      // 如果有验证失败，显示提示并执行回调
      if (!validationResults.isValid) {
        this.$alert(validationResults.errorMessage, '提示', {
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.executeAnswerValidation()
        })
        return false
      }

      return true
    },

    /**
     * @see src/views/order-review/components/OrderSaveAnswerButton.vue onSaveAnswer
     * @see src/views/order-review/components/ReviewAuditQualityButton.vue reviewAuditQuality
     * @returns {Promise<never>|Promise<*>}
     */
    checkAnswerBeforeSave () {
      if (!this.checkSJFOrderValid()) {
        return Promise.reject(new Error('校验未通过'))
      }
      return this.validateAnswer()
    },

    /**
     * 执行SJF相关验证
     * @returns {Object} 验证结果
     */
    performSJFValidations () {
      const questionMap = this.buildQuestionMap()

      // 验证用酒一致性
      const wineValidation = this.validateWineConsistency(questionMap)

      // 验证二维码是否异常
      const qrcodeValidation = this.validateQrcodeConsistency(questionMap)
      if (!wineValidation.isValid || !qrcodeValidation.isValid) {
        const errors = []
        if (!wineValidation.isValid) {
          errors.push('当前选择用酒与提报用酒的酒品不一致')
        }
        if (!qrcodeValidation.isValid) {
          errors.push('请注意, 无正常的二维码')
        }
        return {
          isValid: false,
          errorMessage: errors.join('<br>')
        }
      }

      return { isValid: true }
    },

    /**
     * 构建问题映射表
     * @returns {Map} 问题ID到问题对象的映射
     */
    buildQuestionMap () {
      const validQuestions = QuestionReview().getValidQuestions()
      const questionMap = new Map()

      validQuestions.forEach(item => {
        questionMap.set(item.id, item)
      })

      return questionMap
    },

    /**
     * 验证用酒一致性
     * @param {Map} questionMap 问题映射表
     * @returns {Object} 验证结果
     */
    validateWineConsistency (questionMap) {
      const templateQuestions = _.get(this, 'sjfOrderDetail.template_questions', {})
      const WINE_QUESTION_TITLE = _.get(templateQuestions, 'title_banquet_product_name') || '【拍照】现场桌面用酒，体现品项、数量、毫升数【必选】'
      const wineQuestion = this.findQuestionByTitle(questionMap, WINE_QUESTION_TITLE)

      if (!wineQuestion) {
        return { isValid: true }
      }

      const answer = QuestionReview().getAnswer(wineQuestion.id)
      const selectedOptionIds = answer.selectedOptionId || []

      if (selectedOptionIds.length === 0) {
        return { isValid: true }
      }

      const selectedOption = this.findOptionById(wineQuestion.options, selectedOptionIds[0])

      const reportedProductName = _.get(this, 'sjfOrderDetail.yxh__productName')
      // 提报信息缺失时，跳过该校验，避免误判/运行时异常
      if (!reportedProductName) {
        return { isValid: true }
      }

      if (selectedOption && selectedOption.title !== reportedProductName) {
        return {
          isValid: false,
          errorMessage: '当前选择用酒与提报用酒的酒品不一致'
        }
      }

      return { isValid: true }
    },

    /**
     * 验证桌数一致性
     * @param {Map} questionMap 问题映射表
     * @returns {Object} 验证结果
     */
    validateTableConsistency (questionMap) {
      const templateQuestions = _.get(this, 'sjfOrderDetail.template_questions', {})
      const TABLE_QUESTION_TITLE = _.get(templateQuestions, 'title_banquet_table_count') || '【整数填写】请清点并填写本次宴会桌数（包括包厢内桌数）【必选】'
      const tableQuestion = this.findQuestionByTitle(questionMap, TABLE_QUESTION_TITLE)

      if (!tableQuestion) {
        return { isValid: true }
      }

      const answer = QuestionReview().getAnswer(tableQuestion.id)
      const inputTableNum = Number(answer.text) || 0
      const reportedTableNumRaw = _.get(this, 'sjfOrderDetail.yxh__tableNum')
      if (reportedTableNumRaw === undefined || reportedTableNumRaw === null || reportedTableNumRaw === '') {
        return { isValid: true }
      }
      const reportedTableNum = Number(reportedTableNumRaw) || 0

      if (inputTableNum !== reportedTableNum) {
        return {
          isValid: false,
          errorMessage: '当前填写桌数与提报宴席桌数不一致'
        }
      }

      return { isValid: true }
    },
    /**
     * 验证扫码题是否存在证据
     * @param {Map} questionMap 问题映射表
     * @returns {Object} 验证结果
     */
    validateQrcodeConsistency (questionMap) {
      const TABLE_QUESTION_TITLE = '【扫码】扫描水井坊瓶码或盒码【必选】'
      const qrcodeQuestion = this.findQuestionByTitle(questionMap, TABLE_QUESTION_TITLE)

      const TABLE_QUESTION_TITLE_2 = '【瓶码/盒码】请寻找用酒瓶/盒准备扫码【必选】'
      const qrcodeOrImageQuestion = this.findQuestionByTitle(questionMap, TABLE_QUESTION_TITLE_2)

      if (!qrcodeQuestion && !qrcodeOrImageQuestion) {
        return { isValid: true }
      }

      if (qrcodeQuestion) {
        const answer = QuestionReview().getAnswer(qrcodeQuestion.id)
        if (answer.evidences && answer.evidences.length === 0) {
          return {
            isValid: false,
            errorMessage: '请注意, 无正常的二维码'
          }
        } else {
          // 二维码异常也需要提示
          const items = answer.evidences.filter(item => [1, 2, 3].includes(item.status))
          if (items.length > 0) {
            return {
              isValid: false,
              errorMessage: '请注意, 无正常的二维码'
            }
          }
        }
      }

      if (qrcodeOrImageQuestion) {
        const qrcodeOrImageAnswer = QuestionReview().getAnswer(qrcodeOrImageQuestion.id)
        const selectedId = qrcodeOrImageAnswer.selectedOptionId.length > 0 ? qrcodeOrImageAnswer.selectedOptionId[0] : null
        if (selectedId) {
          const item = _.find(qrcodeOrImageQuestion.options, { id: selectedId })
          if (item.title === '无完整盒码/瓶码-请拍照') {
            return {
              isValid: false,
              errorMessage: '请注意, 无正常的二维码'
            }
          }
        }
      }

      return { isValid: true }
    },

    /**
     * 根据标题查找问题
     * @param {Map} questionMap 问题映射表
     * @param {string} title 问题标题
     * @returns {Object|undefined} 问题对象
     */
    findQuestionByTitle (questionMap, title) {
      for (const question of questionMap.values()) {
        if (question.title === title) {
          return question
        }
      }
      return undefined
    },

    /**
     * 根据ID查找选项
     * @param {Array} options 选项数组
     * @param {string} id 选项ID
     * @returns {Object|undefined} 选项对象
     */
    findOptionById (options, id) {
      return options.find(option => option.id === id)
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/order-review/mixins/order-review-validate.mixin.js